module.exports = __webpack_public_path__ + "static/media/group_30@2x.73e27a7b.png";